import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { Modal, Button } from "react-bootstrap";
import { API_URL } from "./Constants";
import DOMPurify from "dompurify";
import { htmlToText } from "html-to-text";
import "../StoryList.css"; // Assuming custom styles for the toggle switch are in this file

export default function QueryList() {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const authToken = localStorage.getItem("token");
  const [visibleDropdown, setVisibleDropdown] = useState(null);
  const [errors, setErrors] = useState({});
  const [query, setQuery] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_URL}/Query`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setQuery(response.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const toggleDropdown = (id) => {
    setVisibleDropdown(visibleDropdown === id ? null : id);
  };

  const closeOpenMenus = (e) => {
    if (visibleDropdown && !dropdownRef.current?.contains(e.target)) {
      setTimeout(() => {
        setVisibleDropdown(null);
      }, 300);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeOpenMenus);
    return () => {
      document.removeEventListener("mousedown", closeOpenMenus);
    };
  }, [visibleDropdown]);

  useEffect(() => {
    fetchData();
  }, []);

  const goToAddQuery = () => {
    navigate("/admin/add-query");
  };

  const toggleStatus = async (id, pageName, currentStatus) => {
    const newStatus = currentStatus === 1 ? 2 : 1;
    try {
      await axios.post(`${API_URL}/toggleStatus/${id}/${pageName}`, { status: newStatus }, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success(`Query ${newStatus === 1 ? 'activated' : 'deactivated'} successfully`);
      fetchData();
    } catch (error) {
      console.error("Error toggling status", error);
      toast.error("Failed to toggle status");
    }
  };

  const deleteQuery= async (id, pageName) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_URL}/deleteQuery/${id}/${pageName}`, {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          });
          toast.success("Query deleted successfully");
          fetchData();
        } catch (error) {
          console.error("Error deleting query", error);
          toast.error("Failed to delete the query");
        }
      }
    });
  };

  const truncateHTML = (html, numWords) => {
    const text = htmlToText(html, { wordwrap: false });
    const truncatedText = text.split(" ").slice(0, numWords).join(" ") + "...";
    return truncatedText;
  };

  const handleDescriptionClick = (msg_subject) => {
    setModalContent(msg_subject);
    setShowModal(true);
  };

  const goToEditQuery = (id) => {
    navigate(`/admin/edit-query/${id}`);
  };

  return (
    <>
      <div>
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">
            <div className="layout-page">
              <div className="content-wrapper" style={{ display: "inline-block" }}>
                <ToastContainer />
                <div className="col-12 px-4 mt-4">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="container-xxl flex-grow-1 container-p-y">
                        <h4>
                          <span className="fw-light text-dark">Query List</span>
                        </h4>
                        {/* <button
                          type="button"
                          className="btn btn-primary rounded-pill"
                          onClick={goToAddStory}
                        >
                          <i className="ti ti-plus ti-xs"></i>Add Story
                        </button> */}
                      </div>
                      <div className="row">
                        <div className="card">
                          <div className="table-responsive text-nowrap">
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <th>Sr. no</th>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <th>Phone Number</th>
                                  <th>Description</th>
                                </tr>
                              </thead>
                              <tbody className="table-border-bottom-0">
                                {query.map &&
                                  query.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>{index + 1}</td>
                                     
                                      <td>
                                        <span className="fw-medium">{item.name}</span>
                                      </td>
                                      <td>{item.email}</td>
                                      <td>{item.phone_number}</td>
                                      <td>
                                        <span
                                          onClick={() => handleDescriptionClick(item.msg_subject)}
                                          style={{ cursor: "pointer", textDecoration: "underline" }}
                                        >
                                          {truncateHTML(item.msg_subject, 20)}
                                        </span>
                                      </td>
                                     
                                    
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content-backdrop fade"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Full Description */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Full Description</Modal.Title>
        </Modal.Header>
        <Modal.Body dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modalContent) }} />
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
